import React from 'react';
import {Link} from 'react-router-dom';

/**
 * Public-site chrome. Deliberately separate from `components/Header.tsx`, which is the signed-in
 * app header (project switcher, running-job pill) and must never appear on a marketing page.
 */

interface MarketingHeaderProps {
    isAuthenticated: boolean;
    onSignOut: () => void;
}

const MarketingHeader: React.FC<MarketingHeaderProps> = ({isAuthenticated, onSignOut}) => {
  return (
    <header className="sticky top-0 z-50 border-b border-gray-700 bg-gray-800 shadow-lg">
      <nav className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2">
          <Link to="/" className="flex items-center gap-2 text-xl sm:text-2xl font-bold text-white hover:text-primary-400 transition-colors">
            <img src="/censorme.svg" alt="CensorMe Logo" className="w-6 h-6" />
            <p>CensorMe</p>
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-6">
          <Link to="/docs" className="text-sm text-gray-300 hover:text-white transition-colors">
                        Documentation
          </Link>
          <Link to="/downloads" className="text-sm text-gray-300 hover:text-white transition-colors">
                        Download Mapper
          </Link>
        </div>

        <div className="flex flex-wrap items-center gap-2 sm:gap-4">
          {isAuthenticated ? (
            <>
              <Link
                to="/welcome"
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                                Open App
              </Link>
              <Link
                to="/account"
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                                Account
              </Link>
              <button
                onClick={onSignOut}
                className="rounded-md bg-gray-700 px-3 sm:px-4 py-1.5 sm:py-2 text-sm text-gray-300 hover:bg-gray-600 transition-colors"
              >
                                Sign Out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                                Login
              </Link>
              <Link
                to="/signup"
                className="rounded-md bg-primary-600 px-3 sm:px-4 py-1.5 sm:py-2 text-sm text-white hover:bg-primary-700 transition-colors"
              >
                                Start Trial
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

export default MarketingHeader;
